import BaseModal from "../BaseModal/BaseModal";
import FormButton from "../../components/Form/Button/FormButton";
import React from "react";
import useForm from "../../hooks/useForm";
import FormNoneFieldErrors from "../../components/Form/FormNoneFieldErrors";
import URLS from "../../API/Axios/URLS";
import {toast} from "react-toastify";

export default function TestedDateModal({className, isOpen, setOpen, onSuccess, questionId, ...props}) {
    const [form, error, loading, setFormData, actions] = useForm({
        date: ""
    })

    function submitDate() {
        if (!form.date) {
            actions.setError({
                non_field_errors: ["Please select a date"],
            });
            return;
        }
        actions.post(URLS.addToTested, data => ({
            tested_at: form.date,
            question: questionId
        })).then(response => {
            //     clear the form
            setFormData({
                date: ""
            })
            if (onSuccess)
                onSuccess(response?.data)
            toast.success(
                response?.message || "Tested date added successfully"
            )
            setOpen(false)
        }).catch(error => {
            if (error?.response?.status === 400)
                actions.setError(error?.response?.data?.error);
            else
                actions.setError({non_field_errors: ["Something went wrong"]})
        })
    }

    if (!questionId) return null
    return (
        <BaseModal innerClassName={"md:w-[600px]"} isBoxOpen={isOpen} autoClose={false} defaultHeader={true}
                   title={"Select the date you took the test"}
                   setIsBoxOpen={setOpen}>
            <form className={"flex flex-col gap-4 p-4"}>
                <input type="date"
                       value={form?.date}
                       onChange={(e) => {
                           setFormData({
                               date: e.target.value
                           })
                           actions.setError({})
                       }}
                       className={"border-[1px] rounded-lg p-2"}/>

                <FormNoneFieldErrors
                    errors={actions.concatenatedErrors(error) || []}/>

                <FormButton
                    loading={loading}
                    onClick={submitDate}
                    className={"h-[40px]"}>
                    Submit
                </FormButton>
            </form>


        </BaseModal>

    )
}